// extracted by mini-css-extract-plugin
export var active = "v_bL";
export var menu = "v_M";
export var section = "v_t";
export var title = "v_s";